



































import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { Inquiry } from "@/model/inquiry";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import InquiryList from "@/components/inquiry/InquiryList.vue";
import { HOPE_CONTACT_DIV, ANSWER_ASSIGN } from "@/consts/inquiry";
import { ColumnKey, FilterClause } from "#/components/selectFilter/filter";
import { SELECT_FILTER } from "#/const";
import FireStoreMixin from "#/mixins/firestoreMixin";
import { COLLECTION_INQUIRY_FILTER_OBJ } from "@/consts/envFireStore";
import UserMixin from "@/mixins/userMixin";

export interface HeaderColumn {
  text: string;
  value: string;
  sortable: boolean;
  align?: string;
  width?: string;
  selected?: boolean;
  filterCondition?: number;
  filterType?: number;
  filter?: (val: object) => boolean;
  columnKey?: ColumnKey;
}

interface AssignableAdmin {
  id: number;
  last_name: string;
  first_name: string;
}

interface InquiryOverride {
  userId: number;
  userName: string;
}

/** 表示用Inquiry */
interface DispInquiry extends Inquiry {
  ticket_no: string;
  last_answered_datetime: string;
  co_code: string;
  kst_no: string;
  corresponding_admin_names: string;
  use_receipt_type: number;
  inquiry_date: string;
  inquiry_time: string;
  all_answer_contents: string;
  answer_statuses: number;
  need_mark_hope_contact_date_time: number;
  inquiry_staff_name: string;
  inquiry_staff_furigana: string;
  co_name: string;
  office_name: string;
  normalized_inquiry_content: string;
}

interface InquiryFilterClauses {
  clauses: FilterClause[];
  sortBy: unknown[];
  sortDesc: unknown[];
}

@Component({
  components: {
    InquiryList,
  },
})
export default class ProgressDialog extends Mixins(
  AxiosMixin,
  UtilMixin,
  FireStoreMixin,
  UserMixin
) {
  @Prop({ default: () => [] }) private readonly inquirys!: DispInquiry[];
  @Prop({ default: false }) private readonly value!: boolean;
  @Prop({ default: () => [] }) private readonly adminUsers!: AssignableAdmin[];

  @Emit("input") private updateValue(val: boolean) {
    return val;
  }

  @Emit("save") private save() {
    return Object.entries(this.inquiryOverrides).map(([id, override]) => ({
      inquiry_id: Number(id),
      admin_user_id: override.userId,
      admin_user_name: override.userName,
    }));
  }

  /** 並び項目 */
  private sortBy: unknown[] = [];

  /** 並び順 */
  private sortDesc: unknown[] = [];

  /** 問い合わせタグマスタ */
  private inquiryTagNames: string[] = [];

  /** ダイアログ内で編集中の問い合わせリスト */
  private localInquiries: DispInquiry[] = [];

  /** 対応者変更の上書き情報 */
  private inquiryOverrides: { [id: number]: InquiryOverride } = {};

  @Watch("inquirys", { immediate: true })
  private onInquirysChange(val: DispInquiry[]) {
    this.localInquiries = JSON.parse(JSON.stringify(val));
    this.inquiryOverrides = {};
  }

  private get Value(): boolean {
    return this.value;
  }
  private set Value(val: boolean) {
    this.updateValue(val);
  }

  /** ヘッダー情報 */
  private get headers(): HeaderColumn[] {
    return [
      {
        text: "",
        value: "inquiry_tag_name",
        sortable: false,
        align: "center",
        selected: false,
        width: "100px",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "inquiry_tag_name",
          text: "問い合わせタグ",
          selectable: this.inquiryTagNames,
        },
      },
      {
        text: "詳細",
        value: "actions",
        sortable: false,
        align: "center",
        selected: false,
        width: "50px",
      },
      {
        text: "ステータス",
        sortable: false,
        value: "status",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EQUAL_LIST,
          key: "status",
          text: "ステータス",
          selectable: ["未対応", "進行中", "連絡とれず"],
        },
        width: "150px",
      },
      {
        text: "バージョン",
        sortable: false,
        value: "version",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "version",
          text: "バージョン",
          selectable: ["v2", "v1"],
        },
        width: "100px",
      },
      {
        text: "回答ステータス(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "answer_statuses",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "answer_statuses",
          text: "回答ステータス",
          selectable: [
            "アサイン",
            "対応中",
            "連絡待ち（外）",
            "連絡待ち（内）",
            "回答なし",
          ],
        },
      },
      {
        text: "問い合わせ公開設定(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "is_published",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "is_published",
          text: "問い合わせ公開設定",
          selectable: ["非公開", "公開"],
        },
      },
      {
        text: "回答公開設定(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "answer_is_published",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "answer_is_published",
          text: "回答公開設定",
          selectable: ["非公開", "公開"],
        },
      },
      {
        text: "自動フラグ(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "is_auto",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "is_auto",
          text: "アサイン設定",
          selectable: ["手動", "自動"],
        },
      },
      {
        text: "問い合わせ内容(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "normalized_inquiry_content",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "normalized_inquiry_content",
          text: "問い合わせ内容",
          selectable: [],
        },
      },
      {
        text: "希望連絡方法(チケット番号)",
        align: "center",
        sortable: false,
        value: "hope",
        width: "190px",
      },
      {
        text: "希望連絡方法(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "hope_contact_div",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "hope_contact_div",
          text: "希望連絡方法",
          selectable: HOPE_CONTACT_DIV.map((choice) => choice.text),
        },
      },
      {
        text: "チケット番号(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "ticket_no",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "ticket_no",
          text: "チケット番号",
          selectable: [],
        },
      },
      {
        text: "企業コード(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "co_code",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "co_code",
          text: "企業コード",
          selectable: [],
        },
      },
      {
        text: "KST番号(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "kst_no",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "kst_no",
          text: "KST番号",
          selectable: [],
        },
      },
      {
        text: "回答内容(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "all_answer_contents",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "all_answer_contents",
          text: "回答内容",
          selectable: [],
        },
      },
      {
        text: "事業所名",
        align: "start",
        sortable: true,
        value: "office_name",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "office_name",
          text: "事業所名",
          selectable: [],
        },
        width: "180px",
      },
      {
        text: "対応者",
        align: "start",
        sortable: false,
        value: "corresponding_admin_names",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "corresponding_admin_names",
          text: "対応者",
          selectable: [],
        },
        width: "150px",
      },
      {
        text: "問い合わせ日",
        align: "start",
        sortable: true,
        value: "inquiry_date",
        width: "150px",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.DATE,
          key: "inquiry_date",
          text: "問合せ日",
          selectable: [],
        },
      },
      {
        text: "問い合わせ時刻",
        align: "start",
        sortable: true,
        value: "inquiry_time",
        width: "150px",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "inquiry_time",
          text: "問合せ時刻",
          selectable: [],
        },
      },
      {
        text: "希望連絡日時",
        align: "start",
        sortable: true,
        value: "hope_contact_datetime",
        width: "150px",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.DATE,
          key: "hope_contact_datetime",
          text: "希望連絡日時",
          selectable: [],
        },
      },
      {
        text: "最終回答日時",
        align: "start",
        sortable: true,
        value: "last_answered_datetime",
        width: "150px",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.DATE,
          key: "last_answered_datetime",
          text: "最終回答日時",
          selectable: [],
        },
      },
      {
        text: "企業名",
        align: "start",
        sortable: true,
        value: "co_name",
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "co_name",
          text: "企業名",
          selectable: [],
        },
        width: "150px",
      },
    ];
  }

  async created() {
    this.collection = COLLECTION_INQUIRY_FILTER_OBJ;
    this.documentId = String(this.User.id);
    const data = await this.documentGet();
    if (data) {
      const clauses = data as InquiryFilterClauses;
      this.sortBy = clauses.sortBy;
      this.sortDesc = clauses.sortDesc;
    }
  }

  /** 対応者変更イベントハンドラ */
  private onAssignChange({
    inquiryId,
    adminUserId,
    adminUserName,
  }: {
    inquiryId: number;
    adminUserId: number;
    adminUserName: string;
  }) {
    this.inquiryOverrides = {
      ...this.inquiryOverrides,
      [inquiryId]: { userId: adminUserId, userName: adminUserName },
    };
    const inquiry = this.localInquiries.find((i) => i.id === inquiryId);
    if (!inquiry) return;
    const assignAnswer = inquiry.inquiry_answers?.find(
      (a) => a.answer_status === ANSWER_ASSIGN
    );
    if (assignAnswer) {
      assignAnswer.answer_admin_id = adminUserId;
      assignAnswer.answer_admin_name = adminUserName;
    }
    inquiry.corresponding_admin_names = adminUserName;
  }

  //並び順序変更
  private updateSortBy(value: []) {
    this.sortBy = value;
  }

  //並び項目変更
  private updateSortDesc(value: []) {
    this.sortDesc = value;
  }
}
